import { SingleProductDetails } from "@emerson/components/SingleProductDetails/SingleProductDetails";
import { emersonRoutes } from "@emerson/data/emersonRoutes";
import { useMatch, Navigate } from "@shared/react-router-dom/react-router-dom";

const ProductDetailsPage = () => {
  const productDetailPath = `${emersonRoutes.pdp}` as const;
  const match = useMatch<"productId", typeof productDetailPath>(productDetailPath);
  const productId = match?.params?.productId;

  if (!productId) {
    return <Navigate to={emersonRoutes.base} replace />;
  }

  return (
    <section>
      <SingleProductDetails productId={productId} />
    </section>
  );
};

export { ProductDetailsPage };
